import { useState } from 'react';

type DataDisclosureChoices = {
  localDataAck: boolean;
  cloudBackupAck: boolean;
  billingAck: boolean;
  personalizedAds: boolean;
};

type DataDisclosureModalProps = {
  labels: {
    title: string;
    body: string;
    localData: string;
    cloudBackup: string;
    billing: string;
    personalizedAds: string;
    continue: string;
    exit: string;
    requiredHint: string;
  };
  onAccept: (choices: DataDisclosureChoices) => void;
  onExit: () => void;
};

export function DataDisclosureModal({ labels, onAccept, onExit }: DataDisclosureModalProps) {
  const [localDataAck, setLocalDataAck] = useState(false);
  const [cloudBackupAck, setCloudBackupAck] = useState(false);
  const [billingAck, setBillingAck] = useState(false);
  const [personalizedAds, setPersonalizedAds] = useState(false);
  const canContinue = localDataAck && cloudBackupAck && billingAck;

  return (
    <div className="sheet-overlay" onClick={() => undefined}>
      <div className="sheet onboarding-sheet legal-consent-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="sheet-header">
          <h3>{labels.title}</h3>
        </div>
        <div className="small legal-consent-body">{labels.body}</div>
        <div className="card disclosure-card">
          <label className="setting-row">
            <span>{labels.localData}</span>
            <input type="checkbox" checked={localDataAck} onChange={(e) => setLocalDataAck(e.target.checked)} />
          </label>
          <label className="setting-row">
            <span>{labels.cloudBackup}</span>
            <input type="checkbox" checked={cloudBackupAck} onChange={(e) => setCloudBackupAck(e.target.checked)} />
          </label>
          <label className="setting-row">
            <span>{labels.billing}</span>
            <input type="checkbox" checked={billingAck} onChange={(e) => setBillingAck(e.target.checked)} />
          </label>
          <label className="setting-row">
            <span>{labels.personalizedAds}</span>
            <input type="checkbox" checked={personalizedAds} onChange={(e) => setPersonalizedAds(e.target.checked)} />
          </label>
        </div>
        {!canContinue && <div className="small disclosure-required-hint">{labels.requiredHint}</div>}
        <div className="timer-buttons onboarding-actions">
          <button onClick={onExit}>{labels.exit}</button>
          <button
            disabled={!canContinue}
            onClick={() =>
              onAccept({
                localDataAck,
                cloudBackupAck,
                billingAck,
                personalizedAds
              })
            }
          >
            {labels.continue}
          </button>
        </div>
      </div>
    </div>
  );
}
